import { ReviewTemplate } from './components/review-assessment-sections/review-assessment-sections.component'

export const DVM_REVIEW_TEMPLATE: ReviewTemplate = {
   reviewType: 'DVM',
   sections: [
      {
         id: 'section_a',
         revieweeTitle: 'Job Satisfaction & Well-Being',
         reviewerTitle: 'Engagement & Professional Fulfillment',
         questions: [
            {
               id: 'job_satisfaction',
               type: 'radio',
               required: true,
               revieweeLabel: 'Overall satisfaction',
               revieweeOptions: [
                  {
                     label: 'Very Satisfied',
                     value: 'very_satisfied',
                  },
                  {
                     label: 'Satisfied',
                     value: 'satisfied',
                  },
                  {
                     label: 'Neutral',
                     value: 'neutral',
                  },
                  {
                     label: 'Dissatisfied',
                     value: 'dissatisfied',
                  },
                  {
                     label: 'Very Dissatisfied',
                     value: 'very_dissatisfied',
                  },
               ],
               reviewerLabel: 'Observed engagement and connection to work',
               reviewerOptions: [
                  {
                     label: 'Highly engaged and energized',
                     value: 'highly_engaged',
                  },
                  {
                     label: 'Engaged and positive',
                     value: 'engaged_positive',
                  },
                  {
                     label: 'Generally steady',
                     value: 'generally_steady',
                  },
                  {
                     label: 'Occasionally disengaged',
                     value: 'occasionally_disengaged',
                  },
                  {
                     label: 'Would benefit from additional support',
                     value: 'needs_support',
                  },
               ],
            },
            {
               id: 'job_satisfaction_factors',
               type: 'checkbox',
               required: true,
               options: [
                  {
                     label: 'Case variety',
                     value: 'case_variety',
                  },
                  {
                     label: 'Team support',
                     value: 'team_support',
                  },
                  {
                     label: 'Client relationships',
                     value: 'client_relationships',
                  },
                  {
                     label: 'Work\u2013life balance',
                     value: 'work_life_balance',
                  },
                  {
                     label: 'Autonomy',
                     value: 'autonomy',
                  },
                  {
                     label: 'Stress level',
                     value: 'stress_level',
                  },
                  {
                     label: 'Caseload',
                     value: 'caseload',
                  },
                  {
                     label: 'Leadership interactions',
                     value: 'leadership_interactions',
                  },
               ],
               revieweeLabel: 'Top factors influencing satisfaction (select up to 3)',
               maxSelections: 3,
               hasOther: true,
               reviewerLabel: 'Key factors positively influencing engagement (select up to 3)',
            },
            {
               id: 'job_satisfaction_notes',
               type: 'textarea',
               required: false,
               maxLength: 1000,
               revieweeLabel: 'Notes',
               reviewerLabel: 'Manager Notes',
            },
         ],
      },
      {
         id: 'section_b',
         revieweeTitle: 'Medical Quality & Clinical Skills',
         reviewerTitle: 'Medical Quality & Clinical Growth',
         questions: [
            {
               id: 'clinical_proficiency',
               type: 'radio',
               required: true,
               revieweeLabel: 'Self-assessed proficiency',
               revieweeOptions: [
                  {
                     label: 'Excellent',
                     value: 'excellent',
                  },
                  {
                     label: 'Strong',
                     value: 'strong',
                  },
                  {
                     label: 'Competent',
                     value: 'competent',
                  },
                  {
                     label: 'Needs development',
                     value: 'needs_development',
                  },
                  {
                     label: 'Needs major support',
                     value: 'needs_major_support',
                  },
               ],
               reviewerLabel: 'Observed clinical effectiveness',
               reviewerOptions: [
                  {
                     label: 'Outstanding strength',
                     value: 'outstanding_strength',
                  },
                  {
                     label: 'Strong and consistent',
                     value: 'strong_consistent',
                  },
                  {
                     label: 'Solid and dependable',
                     value: 'solid_dependable',
                  },
                  {
                     label: 'Developing confidence',
                     value: 'developing_confidence',
                  },
                  {
                     label: 'Needs focused support',
                     value: 'needs_support',
                  },
               ],
            },
            {
               id: 'areas_to_develop',
               type: 'checkbox',
               required: true,
               options: [
                  {
                     label: 'Surgery',
                     value: 'surgery',
                  },
                  {
                     label: 'Dentistry',
                     value: 'dentistry',
                  },
                  {
                     label: 'Emergency/Urgent Care',
                     value: 'emergency_care',
                  },
                  {
                     label: 'Ultrasound',
                     value: 'ultrasound',
                  },
                  {
                     label: 'Internal Medicine',
                     value: 'internal_medicine',
                  },
                  {
                     label: 'Behavior',
                     value: 'behavior',
                  },
                  {
                     label: 'Exotics',
                     value: 'exotics',
                  },
                  {
                     label: 'Client communication',
                     value: 'client_communication',
                  },
               ],
               revieweeLabel: 'Areas to develop next year (select up to 3)',
               maxSelections: 3,
               hasOther: true,
               reviewerLabel: 'Priority growth opportunities for the coming year (select up to 3)',
            },
            {
               id: 'clinical_skills_notes',
               type: 'textarea',
               required: false,
               maxLength: 1000,
               revieweeLabel: 'Notes',
               reviewerLabel: 'Manager Notes',
            },
         ],
      },
      {
         id: 'section_c',
         revieweeTitle: 'Workload, Scheduling & Efficiency',
         reviewerTitle: 'Workflow, Time Management & Efficiency',
         questions: [
            {
               id: 'caseload_manageability',
               type: 'radio',
               required: true,
               revieweeLabel: 'Caseload feels',
               revieweeOptions: [
                  {
                     label: 'Very manageable',
                     value: 'very_manageable',
                  },
                  {
                     label: 'Manageable',
                     value: 'manageable',
                  },
                  {
                     label: 'Occasionally overwhelming',
                     value: 'occasionally_overwhelming',
                  },
                  {
                     label: 'Frequently overwhelming',
                     value: 'frequently_overwhelming',
                  },
                  {
                     label: 'Unsustainable',
                     value: 'unsustainable',
                  },
               ],
               reviewerLabel: 'Observed ability to manage workload',
               reviewerOptions: [
                  {
                     label: 'Highly effective and organized',
                     value: 'highly_effective',
                  },
                  {
                     label: 'Consistently effective',
                     value: 'consistently_effective',
                  },
                  {
                     label: 'Generally effective',
                     value: 'generally_effective',
                  },
                  {
                     label: 'Developing consistency',
                     value: 'developing_consistency',
                  },
                  {
                     label: 'Would benefit from added structure/support',
                     value: 'needs_support',
                  },
               ],
            },
            {
               id: 'efficiency_barriers',
               type: 'checkbox',
               required: true,
               options: [
                  {
                     label: 'Staffing',
                     value: 'staffing',
                  },
                  {
                     label: 'Workflows',
                     value: 'workflows',
                  },
                  {
                     label: 'Appointment lengths',
                     value: 'appointment_lengths',
                  },
                  {
                     label: 'Charting time',
                     value: 'charting_time',
                  },
                  {
                     label: 'Client communication',
                     value: 'client_communication',
                  },
                  {
                     label: 'Equipment',
                     value: 'equipment',
                  },
                  {
                     label: 'Scheduling',
                     value: 'scheduling',
                  },
               ],
               revieweeLabel: 'Barriers to efficiency (select up to 3)',
               maxSelections: 3,
               hasOther: true,
               reviewerLabel: 'Opportunities to improve effectiveness (select up to 3)',
            },
            {
               id: 'workload_notes',
               type: 'textarea',
               required: false,
               maxLength: 1000,
               revieweeLabel: 'Notes',
               reviewerLabel: 'Manager Notes',
            },
         ],
      },
      {
         id: 'section_d',
         revieweeTitle: 'Team Dynamics & Communication',
         reviewerTitle: 'Team Collaboration & Communication',
         questions: [
            {
               id: 'communication_quality',
               type: 'radio',
               required: true,
               revieweeLabel: 'Communication quality',
               revieweeOptions: [
                  {
                     label: 'Excellent',
                     value: 'excellent',
                  },
                  {
                     label: 'Good',
                     value: 'good',
                  },
                  {
                     label: 'Inconsistent',
                     value: 'inconsistent',
                  },
                  {
                     label: 'Poor',
                     value: 'poor',
                  },
                  {
                     label: 'Very Poor',
                     value: 'very_poor',
                  },
               ],
               reviewerLabel: 'Observed collaboration with team',
               reviewerOptions: [
                  {
                     label: 'Exceptional team presence',
                     value: 'exceptional_presence',
                  },
                  {
                     label: 'Strong collaborator',
                     value: 'strong_collaborator',
                  },
                  {
                     label: 'Positive contributor',
                     value: 'positive_contributor',
                  },
                  {
                     label: 'Still building confidence',
                     value: 'building_confidence',
                  },
                  {
                     label: 'Would benefit from coaching',
                     value: 'needs_coaching',
                  },
               ],
            },
            {
               id: 'team_challenges',
               type: 'checkbox',
               required: true,
               options: [
                  {
                     label: 'Alignment on medicine',
                     value: 'alignment_medicine',
                  },
                  {
                     label: 'Conflict resolution',
                     value: 'conflict_resolution',
                  },
                  {
                     label: 'Morale',
                     value: 'morale',
                  },
                  {
                     label: 'Delegation',
                     value: 'delegation',
                  },
                  {
                     label: 'Gossip/toxicity',
                     value: 'gossip_toxicity',
                  },
                  {
                     label: 'Training gaps',
                     value: 'training_gaps',
                  },
               ],
               revieweeLabel: 'Team challenges (select up to 3)',
               maxSelections: 3,
               hasOther: true,
               reviewerLabel: 'Team dynamics opportunities (select up to 3)',
            },
            {
               id: 'team_dynamics_notes',
               type: 'textarea',
               required: false,
               maxLength: 1000,
               revieweeLabel: 'Notes',
               reviewerLabel: 'Manager Notes',
            },
         ],
      },
      {
         id: 'section_e',
         revieweeTitle: 'Culture & Support',
         reviewerTitle: 'Culture & Professional Presence',
         questions: [
            {
               id: 'safety_and_trust',
               type: 'radio',
               required: true,
               revieweeLabel: 'Sense of safety and trust',
               revieweeOptions: [
                  {
                     label: 'Very High',
                     value: 'very_high',
                  },
                  {
                     label: 'High',
                     value: 'high',
                  },
                  {
                     label: 'Moderate',
                     value: 'moderate',
                  },
                  {
                     label: 'Low',
                     value: 'low',
                  },
                  {
                     label: 'Very Low',
                     value: 'very_low',
                  },
               ],
               reviewerLabel: 'Contribution to a positive and supportive culture',
               reviewerOptions: [
                  {
                     label: 'Role model',
                     value: 'role_model',
                  },
                  {
                     label: 'Strong contributor',
                     value: 'strong_contributor',
                  },
                  {
                     label: 'Positive presence',
                     value: 'positive_presence',
                  },
                  {
                     label: 'Growing awareness',
                     value: 'growing_awareness',
                  },
                  {
                     label: 'Needs guidance',
                     value: 'needs_guidance',
                  },
               ],
            },
            {
               id: 'cultural_opportunities',
               type: 'checkbox',
               required: true,
               options: [
                  {
                     label: 'Inclusiveness',
                     value: 'inclusiveness',
                  },
                  {
                     label: 'Recognition',
                     value: 'recognition',
                  },
                  {
                     label: 'Transparency',
                     value: 'transparency',
                  },
                  {
                     label: 'Accountability',
                     value: 'accountability',
                  },
                  {
                     label: 'Support for mistakes',
                     value: 'support_mistakes',
                  },
                  {
                     label: 'Empathy',
                     value: 'empathy',
                  },
                  {
                     label: 'Adaptability',
                     value: 'adaptability',
                  },
               ],
               revieweeLabel: 'Cultural opportunities (select up to 3)',
               maxSelections: 3,
               hasOther: true,
               reviewerLabel: 'Opportunities for cultural leadership (select up to 3)',
            },
            {
               id: 'culture_notes',
               type: 'textarea',
               required: false,
               maxLength: 1000,
               revieweeLabel: 'Notes',
               reviewerLabel: 'Manager Notes',
            },
         ],
      },
      {
         id: 'section_f',
         revieweeTitle: 'Resources, Equipment & Support Staff',
         reviewerTitle: 'Resources & Support Optimization',
         questions: [
            {
               id: 'equipment_satisfaction',
               type: 'radio',
               required: true,
               revieweeLabel: 'Satisfaction with equipment/support',
               revieweeOptions: [
                  {
                     label: 'Excellent',
                     value: 'excellent',
                  },
                  {
                     label: 'Good',
                     value: 'good',
                  },
                  {
                     label: 'Adequate',
                     value: 'adequate',
                  },
                  {
                     label: 'Needs improvement',
                     value: 'needs_improvement',
                  },
                  {
                     label: 'Critical gaps',
                     value: 'critical_gaps',
                  },
               ],
               reviewerLabel: 'Effectiveness using available tools and resources',
               reviewerOptions: [
                  {
                     label: 'Maximizes resources exceptionally',
                     value: 'maximizes_exceptionally',
                  },
                  {
                     label: 'Uses resources well',
                     value: 'uses_well',
                  },
                  {
                     label: 'Adequate utilization',
                     value: 'adequate',
                  },
                  {
                     label: 'Could benefit from coaching',
                     value: 'needs_coaching',
                  },
                  {
                     label: 'Would benefit from added support',
                     value: 'needs_support',
                  },
               ],
            },
            {
               id: 'resource_needs',
               type: 'checkbox',
               required: true,
               options: [
                  {
                     label: 'Dental equipment',
                     value: 'dental_equipment',
                  },
                  {
                     label: 'Imaging',
                     value: 'imaging',
                  },
                  {
                     label: 'Surgical tools',
                     value: 'surgical_tools',
                  },
                  {
                     label: 'Lab equipment',
                     value: 'lab_equipment',
                  },
                  {
                     label: 'PIMS',
                     value: 'pims',
                  },
                  {
                     label: 'More support staff',
                     value: 'support_staff',
                  },
                  {
                     label: 'Workflow systems',
                     value: 'workflow_systems',
                  },
                  {
                     label: 'Additional Team Training',
                     value: 'additional_team_training',
                  },
               ],
               revieweeLabel: 'Needs (select up to 4)',
               maxSelections: 4,
               hasOther: true,
               reviewerLabel: 'Resources that would enhance success (select up to 4)',
            },
            {
               id: 'resources_notes',
               type: 'textarea',
               required: false,
               maxLength: 1000,
               revieweeLabel: 'Notes',
               reviewerLabel: 'Manager Notes',
            },
         ],
      },
      {
         id: 'section_g',
         revieweeTitle: 'Professional Development & Career Path',
         reviewerTitle: 'Professional Development & Career Direction',
         questions: [
            {
               id: 'career_path_clarity',
               type: 'radio',
               required: true,
               revieweeLabel: 'Career path clarity',
               revieweeOptions: [
                  {
                     label: 'Very clear',
                     value: 'very_clear',
                  },
                  {
                     label: 'Mostly clear',
                     value: 'mostly_clear',
                  },
                  {
                     label: 'Unclear',
                     value: 'unclear',
                  },
                  {
                     label: 'Very unclear',
                     value: 'very_unclear',
                  },
               ],
               reviewerLabel: 'Clarity of career goals',
               reviewerOptions: [
                  {
                     label: 'Very clear and focused',
                     value: 'very_clear',
                  },
                  {
                     label: 'Mostly clear',
                     value: 'mostly_clear',
                  },
                  {
                     label: 'Exploring options',
                     value: 'exploring',
                  },
                  {
                     label: 'Uncertain',
                     value: 'uncertain',
                  },
                  {
                     label: 'Needs coaching',
                     value: 'needs_coaching',
                  },
               ],
            },
            {
               id: 'growth_interests',
               type: 'checkbox',
               required: true,
               options: [
                  {
                     label: 'Leadership',
                     value: 'leadership',
                  },
                  {
                     label: 'Specialty skills',
                     value: 'specialty_skills',
                  },
                  {
                     label: 'Additional CE',
                     value: 'additional_ce',
                  },
                  {
                     label: 'Mentorship',
                     value: 'mentorship',
                  },
                  {
                     label: 'Business/operations',
                     value: 'business_operations',
                  },
                  {
                     label: 'Research/teaching',
                     value: 'research_teaching',
                  },
               ],
               revieweeLabel: 'Growth interests (select up to 3)',
               maxSelections: 3,
               hasOther: true,
               reviewerLabel: 'Recommended development focus areas (select up to 3)',
            },
            {
               id: 'professional_dev_notes',
               type: 'textarea',
               required: false,
               maxLength: 1000,
               revieweeLabel: 'Notes',
               reviewerLabel: 'Manager Notes',
            },
         ],
      },
      {
         id: 'section_h',
         revieweeTitle: 'Leadership & Practice Operations',
         reviewerTitle: 'Contribution to Practice Success',
         questions: [
            {
               id: 'leadership_support',
               type: 'radio',
               required: true,
               revieweeLabel: 'Support for day-to-day success',
               revieweeOptions: [
                  {
                     label: 'Excellent',
                     value: 'excellent',
                  },
                  {
                     label: 'Good',
                     value: 'good',
                  },
                  {
                     label: 'Generally supportive',
                     value: 'generally_supportive',
                  },
                  {
                     label: 'Some gaps',
                     value: 'some_gaps',
                  },
                  {
                     label: 'Significant gaps',
                     value: 'significant_gaps',
                  },
               ],
               reviewerLabel: 'Level of contribution to hospital success',
               reviewerOptions: [
                  {
                     label: 'Exceptional impact',
                     value: 'exceptional_impact',
                  },
                  {
                     label: 'Strong contributor',
                     value: 'strong_contributor',
                  },
                  {
                     label: 'Reliable contributor',
                     value: 'reliable_contributor',
                  },
                  {
                     label: 'Growing contributor',
                     value: 'growing_contributor',
                  },
                  {
                     label: 'Would benefit from coaching',
                     value: 'needs_coaching',
                  },
               ],
            },
            {
               id: 'operations_opportunities',
               type: 'checkbox',
               required: true,
               options: [
                  {
                     label: 'Communication clarity',
                     value: 'communication_clarity',
                  },
                  {
                     label: 'Consistent follow-through',
                     value: 'follow_through',
                  },
                  {
                     label: 'Staffing processes',
                     value: 'staffing_processes',
                  },
                  {
                     label: 'Scheduling practices',
                     value: 'scheduling_practices',
                  },
                  {
                     label: 'Policy clarity',
                     value: 'policy_clarity',
                  },
                  {
                     label: 'Support during complex or emotionally difficult cases',
                     value: 'support_difficult_cases',
                  },
               ],
               revieweeLabel: 'Opportunities to strengthen practice operations (select up to 3)',
               maxSelections: 3,
               hasOther: true,
               reviewerLabel: 'Opportunities to strengthen contribution (select up to 3)',
            },
            {
               id: 'leadership_notes',
               type: 'textarea',
               required: false,
               maxLength: 1000,
               revieweeLabel: 'Notes',
               reviewerLabel: 'Manager Notes',
            },
         ],
      },
      {
         id: 'section_i',
         revieweeTitle: 'Compensation',
         reviewerTitle: 'Performance',
         questions: [
            {
               id: 'compensation_satisfaction',
               type: 'radio',
               required: true,
               revieweeLabel: 'Overall satisfaction with compensation',
               revieweeOptions: [
                  {
                     label: 'Very satisfied',
                     value: 'very_satisfied',
                  },
                  {
                     label: 'Satisfied',
                     value: 'satisfied',
                  },
                  {
                     label: 'Neutral',
                     value: 'neutral',
                  },
                  {
                     label: 'Dissatisfied',
                     value: 'dissatisfied',
                  },
                  {
                     label: 'Very dissatisfied',
                     value: 'very_dissatisfied',
                  },
               ],
               reviewerLabel: 'Overall performance relative to expectations',
               reviewerOptions: [
                  {
                     label: 'Consistently exceeds expectations',
                     value: 'exceeds_expectations',
                  },
                  {
                     label: 'Fully meets expectations',
                     value: 'meets_expectations',
                  },
                  {
                     label: 'Developing toward expectations',
                     value: 'developing',
                  },
                  {
                     label: 'Needs focused support',
                     value: 'needs_support',
                  },
                  {
                     label: 'Requires improvement',
                     value: 'requires_improvement',
                  },
               ],
            },
            {
               id: 'compensation_needs',
               type: 'checkbox',
               required: true,
               options: [
                  {
                     label: 'Base pay',
                     value: 'base_pay',
                  },
                  {
                     label: 'Production',
                     value: 'production',
                  },
                  {
                     label: 'PTO',
                     value: 'pto',
                  },
                  {
                     label: 'CE time/budget',
                     value: 'ce_time_budget',
                  },
                  {
                     label: 'Benefits package',
                     value: 'benefits_package',
                  },
                  {
                     label: 'Parental leave',
                     value: 'parental_leave',
                  },
                  {
                     label: 'Student loan support',
                     value: 'student_loan_support',
                  },
               ],
               revieweeLabel: 'Areas needing attention (select up to 3)',
               maxSelections: 3,
               hasOther: true,
               reviewerLabel: 'Key strengths influencing performance conversations (select up to 3)',
            },
            {
               id: 'compensation_notes',
               type: 'textarea',
               required: false,
               maxLength: 1000,
               revieweeLabel: 'Notes',
               reviewerLabel: 'Manager Notes',
            },
         ],
      },
      {
         id: 'section_j',
         revieweeTitle: 'Work\u2013Life Balance',
         reviewerTitle: 'Sustainability & Work\u2013Life Integration',
         questions: [
            {
               id: 'work_life_balance',
               type: 'radio',
               required: true,
               revieweeLabel: 'Overall work\u2013life balance',
               revieweeOptions: [
                  {
                     label: 'Excellent',
                     value: 'excellent',
                  },
                  {
                     label: 'Good',
                     value: 'good',
                  },
                  {
                     label: 'Acceptable',
                     value: 'acceptable',
                  },
                  {
                     label: 'Needs improvement',
                     value: 'needs_improvement',
                  },
                  {
                     label: 'Very challenging',
                     value: 'very_challenging',
                  },
               ],
               reviewerLabel: 'Observed sustainability of workload',
               reviewerOptions: [
                  {
                     label: 'Very sustainable',
                     value: 'very_sustainable',
                  },
                  {
                     label: 'Generally sustainable',
                     value: 'generally_sustainable',
                  },
                  {
                     label: 'Occasionally stretched',
                     value: 'occasionally_stretched',
                  },
                  {
                     label: 'At risk without adjustments',
                     value: 'at_risk',
                  },
                  {
                     label: 'High priority to address',
                     value: 'high_priority',
                  },
               ],
            },
            {
               id: 'balance_factors',
               type: 'checkbox',
               required: true,
               options: [
                  {
                     label: 'Schedule flexibility',
                     value: 'schedule_flexibility',
                  },
                  {
                     label: 'Workload/caseload',
                     value: 'workload_caseload',
                  },
                  {
                     label: 'On-call expectations',
                     value: 'oncall_expectations',
                  },
                  {
                     label: 'Time for charting/admin',
                     value: 'charting_admin_time',
                  },
                  {
                     label: 'Mental health support',
                     value: 'mental_health_support',
                  },
                  {
                     label: 'Predictability of schedule',
                     value: 'schedule_predictability',
                  },
               ],
               revieweeLabel: 'Factors affecting balance (select up to 3)',
               maxSelections: 3,
               hasOther: true,
               reviewerLabel: 'Factors influencing sustainability (select up to 3)',
            },
            {
               id: 'balance_notes',
               type: 'textarea',
               required: false,
               maxLength: 1000,
               revieweeLabel: 'Notes',
               reviewerLabel: 'Manager notes',
            },
         ],
      },
      {
         id: 'section_k',
         revieweeTitle: 'Overall Reflection',
         reviewerTitle: 'Overall Impact & Forward Focus',
         questions: [
            {
               id: 'likelihood_of_staying',
               type: 'radio',
               required: true,
               revieweeLabel: 'Likelihood of staying long-term',
               revieweeOptions: [
                  {
                     label: 'Very likely',
                     value: 'very_likely',
                  },
                  {
                     label: 'Likely',
                     value: 'likely',
                  },
                  {
                     label: 'Unsure',
                     value: 'unsure',
                  },
                  {
                     label: 'Unlikely',
                     value: 'unlikely',
                  },
                  {
                     label: 'Very unlikely',
                     value: 'very_unlikely',
                  },
               ],
               reviewerLabel: 'Likelihood of long-term success within the practice',
               reviewerOptions: [
                  {
                     label: 'Very strong potential',
                     value: 'very_strong',
                  },
                  {
                     label: 'Strong potential',
                     value: 'strong',
                  },
                  {
                     label: 'Emerging potential',
                     value: 'emerging',
                  },
                  {
                     label: 'Uncertain without support',
                     value: 'uncertain',
                  },
                  {
                     label: 'Needs intervention',
                     value: 'needs_intervention',
                  },
               ],
            },
            {
               id: 'top_priorities',
               type: 'checkbox',
               required: true,
               options: [
                  {
                     label: 'Efficiency',
                     value: 'efficiency',
                  },
                  {
                     label: 'Skill development',
                     value: 'skill_development',
                  },
                  {
                     label: 'Stress reduction',
                     value: 'stress_reduction',
                  },
                  {
                     label: 'Autonomy',
                     value: 'autonomy',
                  },
                  {
                     label: 'Team relationships',
                     value: 'team_relationships',
                  },
                  {
                     label: 'Compensation',
                     value: 'compensation',
                  },
                  {
                     label: 'Culture',
                     value: 'culture',
                  },
               ],
               revieweeLabel: 'Top priorities for next year (select up to 2)',
               maxSelections: 2,
               hasOther: true,
               reviewerLabel: 'Top focus areas for the coming year (select up to 2)',
            },
            {
               id: 'overall_reflection_notes',
               type: 'textarea',
               required: false,
               maxLength: 1000,
               revieweeLabel: 'Notes',
               reviewerLabel: 'Manager Notes',
            },
         ],
      },
   ],
}
